import { render, staticRenderFns } from "./ImportDataHas.vue?vue&type=template&id=6772f9b2&scoped=true&"
import script from "./ImportDataHas.vue?vue&type=script&lang=js&"
export * from "./ImportDataHas.vue?vue&type=script&lang=js&"
import style0 from "./ImportDataHas.vue?vue&type=style&index=0&id=6772f9b2&lang=less&scoped=true&"
import style1 from "./ImportDataHas.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6772f9b2",
  null
  
)

export default component.exports